class QuickFormQuantitySelector extends HTMLElement {
    constructor() {
        super();
        this.onCartEvent = this.onCartEvent.bind(this);
    }

    connectedCallback() {
        this.cartItems = [];
        this.productItem = this.closest('product-item');
        this.productItemQuickForm = this.productItem?.querySelector('.product-item__quick-form');
        this.quickAddForm = this.productItem?.querySelector('.quick_add_form');
        this.input = this.querySelector('[data-quantity-input]');
        this.btnDecrease = this.querySelector('[data-action="decrease"]');
        this.btnIncrease = this.querySelector('[data-action="increase"]');
        this.variantId = Number(this.getAttribute('variant-id')) || null;

        if (this.btnIncrease) this.btnIncrease.addEventListener('click', () => this.changeQuantity(1));
        if (this.btnDecrease) this.btnDecrease.addEventListener('click', () => this.changeQuantity(-1));
        if (this.input) this.input.addEventListener('change', () => this.updateCart());

        document.addEventListener('cart:loaded', this.onCartEvent);
        document.addEventListener('cart:changed', this.onCartEvent);
        document.addEventListener('cart:refresh', this.onCartEvent);
    }

    disconnectedCallback() {
        document.removeEventListener('cart:loaded', this.onCartEvent);
        document.removeEventListener('cart:changed', this.onCartEvent);
        document.removeEventListener('cart:refresh', this.onCartEvent);
    }

    onCartEvent(e) {
        window.cart.items = e.detail.cart.items;
        this.cartItems = e.detail.cart.items;
        this.syncWithCart()
    }


    changeQuantity(delta) {
        if (!this.input) return;
        let qty = parseInt(this.input.value, 10) || 0;
        qty = Math.max(0, qty + delta);
        this.input.value = qty;
        this.updateCart();
    }

    updateCart() {
        const qty = parseInt(this.input.value, 10) || 0;
        if (!this.cartItems || !this.variantId) return;

        const lineItem = this.cartItems.find(item => item.variant_id === this.variantId);

        if (lineItem) {
            Cart.change(lineItem.key, qty).then(() => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            });;
        } else if (qty > 0) {
            Cart.add(this.variantId, qty).then(() => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            });;
        }
    }

    syncWithCart() {
        if (!this.cartItems || !this.variantId || !this.input) return;

        const lineItem = this.cartItems.find(item => item.variant_id === this.variantId);
        if (lineItem) {
            this.classList.remove('hidden');
            this.quickAddForm?.classList.add('hidden');
            this.input.value = lineItem.quantity;
            this.productItemQuickForm?.classList.add("product-item__quick-form--visible");
        } else {
            this.input.value = 0;
            this.classList.add('hidden');
            this.quickAddForm?.classList.remove('hidden');
            this.productItemQuickForm?.classList.remove("product-item__quick-form--visible");
        }
    }
}

customElements.define('quick-form-quantity-selector', QuickFormQuantitySelector);